import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function SaleBanner() {
  const { lang } = useI18n();
  const [sale, setSale] = useState(null);
  const [closed, setClosed] = useState(() => sessionStorage.getItem("pv_sale_closed") === "1");

  useEffect(() => {
    api.get("/sale/active").then((r) => {
      if (r.data && r.data.active) setSale(r.data);
    }).catch(() => {});
  }, []);

  if (!sale || closed) return null;
  const shopText = lang === "nl" ? "Shop nu" : lang === "de" ? "Jetzt shoppen" : "Shop now";
  const offText = lang === "nl" ? "korting op alles" : lang === "de" ? "Rabatt auf alles" : "off everything";

  return (
    <AnimatePresence>
      <motion.div
        data-testid="sale-banner"
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -40, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[70] bg-[#D12A2F] text-white py-2 px-4 flex items-center justify-center gap-3 text-xs md:text-sm font-mono-label tracking-[0.1em]"
      >
        <span className="font-semibold uppercase">{sale.name || "SALE"}</span>
        <span>·</span>
        <span>−{sale.pct}% {offText}</span>
        <Link to="/shop" className="underline font-semibold hover:no-underline">{shopText} →</Link>
        <button
          onClick={() => { setClosed(true); sessionStorage.setItem("pv_sale_closed", "1"); }}
          className="ml-3 opacity-70 hover:opacity-100"
          aria-label="Close"
        >×</button>
      </motion.div>
    </AnimatePresence>
  );
}
